module.exports = __webpack_public_path__ + "static/media/graficoView.70edee52.svg";